import { useSnackbar } from "@/components/ui-v2/Snackbar";

/** @deprecated use useSnackbar from @/components/ui-v2/Snackbar instead */
const useShowSnackbar = () => useSnackbar();

export { useShowSnackbar };
export default useShowSnackbar;
